import useUrlParams from '../../../../hooks/useUrlParams';
import useContacts from '../../../../hooks/useContacts';
import { SatelliteIcon } from "./Svgs";
import { get_formated_time } from '../../../../utils';

// Function to get CSS class based on status
const getStatusClass = (status) => {
  const statusClasses = {
    Error: 'status__error',
    Scheduled: 'status__schedule',
    Active: 'status__active',
    Completed: 'status__success',
  };
  return statusClasses[status] || '';
};

// Function to truncate text to a max length
const truncateText = (text, maxLength = 7) =>
  text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;

const ContactAlert = () => {
  const { dashboard } = useUrlParams(); // Fetch URL parameters
  const { contacts } = useContacts(); // Fetch contact data

  // Function to create an alert object from a contact
  const createAlert = (contact, type, statusMap) => ({
    groundstation: contact.groundStationName,
    country: contact.groundStationProperties.country,
    type: `${type} contact`,
    time: get_formated_time(contact[type === 'Upcoming' ? 'startTime' : 'endTime']),
    duration: Math.floor((contact.endTime - contact.startTime) / 60),
    status: statusMap[contact.status] || 'Error',
  });

  // Generate alerts based on contact data
  const alerts = [
    ...(contacts?.upcoming_contacts?.slice(0, 1).map(c =>
      createAlert(c, 'Upcoming', { Booked: 'Scheduled', Scheduled: 'Scheduled' })
    ) ?? []),
    ...(contacts?.ongoing_contacts?.map(c =>
      createAlert(c, 'Ongoing', { Booked: 'Active', Scheduled: 'Active' })
    ) ?? []),
    ...(contacts?.previous_contacts?.slice(0, 1).map(c =>
      createAlert(c, 'Previous', { Booked: 'Completed', Scheduled: 'Completed' })
    ) ?? []),
  ];

  return (
    <div className={`alert__section__container ${dashboard === 'operate' ? 'show__alert' : ''}`}>
      {/* commenting this as it will be comming future */}
      {/* <Fragment>
        {notifications.map((noti, index) => (
          <div
            className={`notification__card ${noti.status === 'Error' && 'justify-content-between'}`}
            key={index}
          >
            <div className="d-flex gap-2 align-items-center justify-content-center">
              <div
                className={`status__indicator ${noti.status === 'Error' ? 'status__error' : 'status__schedule'
                  }`}
              />
              <span>{noti.title}</span>
            </div>
            <button className={`${noti.status === 'Error' ? 'status__error' : 'd-none'}`}>
              View
            </button>
          </div>
        ))}
      </Fragment> */}
      {alerts?.map((alert, index) => (
        <div className="alert__card" key={`alert-${index}`}>
          <div className="d-flex align-items-center justify-content-between w-100">
            <div className="d-flex align-items-center gap-2">
              <SatelliteIcon />
              <div className="d-flex flex-column w-100">
                <div className="d-flex justify-content-start align-items-center gap-1">
                  <span title={alert.groundstation}>{truncateText(alert.groundstation)},</span>
                  <span title={alert.country}>{truncateText(alert.country)}</span>
                </div>
                <span className="alert__type__label">{alert.type}</span>
              </div>
            </div>
            <div className={`badge ${getStatusClass(alert.status)}`}>
              <div className={`status__indicator ${getStatusClass(alert.status)} 
                ${['Error', 'Completed'].includes(alert.status) ? 'd-none' : ''}`}
              />
              <span>{alert.status === 'Not Scheduled' ? 'Empty' : alert.status}</span>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-between w-100">
            <div className="badge">{alert.time}</div>
            <div className="badge">{`for ${alert.duration} mins`}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ContactAlert;